import { asNumber, asString, isObject } from "./model-utils";

export class Destination {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.destinationId = asString(json.destinationId);
    this.address = asString(json.address);
    this.amount = asNumber(json.amount);
    this.accessPointName = asString(json.accessPointName);
    this.currency = asString(json.currency);
  }

  static fromJson(json: any) {
    return isObject(json) ? new Destination(json) : json;
  }
}
